import _debounce from 'lodash/debounce';
import Cmp from './ad-cmp-loader';

/* eslint-disable no-undef */
class adStroeer {
  /**
   * @param {Window.haz.ads|{tablet, disabledSlots, desktop, zone, mobile}} configurations
   */
  constructor(configurations) {
    const script = document.createElement('script');
    script.async = true;
    script.src = '//cdn.stroeerdigitalgroup.de/metatag/live/OMS_hildesheim_neu/metaTag.min.js';


    const cmp = new Cmp();
    cmp.waitForConsent(script, 136);

    this.configurations = configurations;
    this.currentViewportName = adStroeer.getViewportName(
      adStroeer.getClientWidth(),
      configurations,
    );

    script.onload = () => {
      adStroeer.configureSlots(cmp, configurations.zone);
      adStroeer.registerSlots(this.currentViewportName, configurations);
    };
  }

  update(throttleTimeout) {
    return _debounce(() => {
      const newViewPortName = adStroeer.getViewportName(
        adStroeer.getClientWidth(),
        this.configurations,
      );

      if (newViewPortName !== this.currentViewportName) {
        adStroeer.registerSlots(newViewPortName, this.configurations);
        this.currentViewportName = newViewPortName;
      }
    }, throttleTimeout);
  }

  static registerSlots(viewportName, configurations) {
    SDG.Publisher.unregisterAllSlots(true);

    const containers = document.getElementsByClassName('js-ad-stroeer');
    if (!containers.length) {
      return;
    }

    const device = configurations[viewportName];
    for (let i = 0; i < device.slots.length; i++) {
      const container = containers[device.slots[i].id];
      const restrictedParent = !!container && container.closest('[class*="show-for-"]');
      const isRestrictedAndVisible = restrictedParent && getComputedStyle(restrictedParent).display !== 'none';

      // Only register slots that are not disabled somehow (e.g. for the current page)
      if (
        adStroeer.isSlotEnabled(device.slots[i].adSlotName, configurations)
        && !!container
        && (!restrictedParent || isRestrictedAndVisible)
      ) {
        // eslint-disable-next-line max-len
        adStroeer.loadSlot(device.slots[i], device.targeting);
      }
    }

    SDG.Publisher.finalizeSlots();
  }

  static isSlotEnabled(slotName, configurations) {
    return !configurations.disabledSlots.includes(slotName);
  }

  static loadSlot(configuration, targeting) {
    const slot = SDG.Publisher.registerSlot(configuration.adSlotName, configuration.id);

    if (configuration.excludedSizes) {
      slot.removeSizes(configuration.excludedSizes);
    }

    slot.setTargeting(targeting);
    slot.load();
  }

  static configureSlots(cmp, zone) {
    // eslint-disable-next-line no-console
    console.info(`[CMP] 755 "Google Advertising Products" for Ströer: ${cmp.getPublicConsentState(__cmp, 755)}, %cNotice: Changes are effective on next page load.`, 'font-style: italic;color: #666');
    SDG.Publisher.setAdServerConsent(cmp.getPublicConsentState(__cmp, 755));
    SDG.Publisher.setZone(zone);
    SDG.Publisher.addKeywords([zone]);
    SDG.Publisher.addKeyValue(zone);
    SDG.Publisher.addKeyValues({ interessen: [zone] });
  }

  static getClientWidth() {
    return Math.max(document.documentElement.getClientWidth || 0, window.innerWidth || 0);
  }

  static getViewportName(clientWidth, configurations) {
    let viewportName = 'desktop';

    if (clientWidth <= configurations.mobile.maxWidth) {
      viewportName = 'mobile';
    } else if (clientWidth > configurations.mobile.maxWidth
      && clientWidth <= configurations.tablet.maxWidth) {
      viewportName = 'tablet';
    } else if (clientWidth > configurations.tablet.maxWidth) {
      viewportName = 'desktop';
    }

    return viewportName;
  }
}
/* eslint-enable no-undef */

export default adStroeer;
